import { render, staticRenderFns } from "./PublicShell.vue?vue&type=template&id=d4ab5448&scoped=true&"
import script from "./PublicShell.vue?vue&type=script&lang=js&"
export * from "./PublicShell.vue?vue&type=script&lang=js&"
import style0 from "./PublicShell.vue?vue&type=style&index=0&id=d4ab5448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ab5448",
  null
  
)

export default component.exports